var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.17,42.17H22.41L34.07,30.5a27.56,27.56,0,1,1,0,39L30.58,73a32.49,32.49,0,1,0,0-46L18.93,38.68h0V24.91a2.47,2.47,0,1,0-4.93,0v22.2H36.17a2.47,2.47,0,0,0,2.46-2.47,2.46,2.46,0,0,0-2.46-2.47Zm17.55-5.44-.1,15,13.13,7.51-2.23,3.91L49.1,54.38l.12-17.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/Revert.554b4edba45df77e703f7f498fbbaf66.svg";
export { ForwardRef as ReactComponent };